var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.235.673 17.876 18.21s-.47 1.216-1.76.633l-7.75-6.154-.037-.018c1.047-.973 9.165-8.532 9.52-8.874.549-.53.208-.847-.43-.446L5.43 11.236.801 9.624s-.728-.268-.798-.851c-.07-.585.822-.9.822-.9L19.686.21s1.55-.705 1.55.462z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.14795e0d3d688a7201f9f27c80df1d4b.svg";
export { ForwardRef as ReactComponent };